import { render, staticRenderFns } from "./button_group.vue?vue&type=template&id=7d8ce20c&scoped=true&"
import script from "./button_group.vue?vue&type=script&lang=ts&"
export * from "./button_group.vue?vue&type=script&lang=ts&"
import style0 from "./button_group.vue?vue&type=style&index=0&id=7d8ce20c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8ce20c",
  null
  
)

export default component.exports